import React, { useState } from "react";

export default function SEOTools() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [content, setContent] = useState("");
  const [density, setDensity] = useState({});
  const [score, setScore] = useState(null);

  // ✅ Analyze SEO
  const analyzeSEO = () => {
    const wordCount = content.split(/\s+/).filter(Boolean).length;
    const keywordList = keywords.split(",").map((k) => k.trim().toLowerCase());

    let densityResult = {};
    let totalHits = 0;

    keywordList.forEach((kw) => {
      const regex = new RegExp(`\\b${kw}\\b`, "gi");
      const matches = content.match(regex);
      const count = matches ? matches.length : 0;
      totalHits += count;
      densityResult[kw] = ((count / wordCount) * 100).toFixed(2) + "%";
    });

    setDensity(densityResult);

    // Simple scoring system
    let tempScore = 0;
    if (title.length > 20 && title.length < 60) tempScore += 20;
    if (description.length > 50 && description.length < 160) tempScore += 20;
    if (keywordList.length > 0) tempScore += 20;
    if (totalHits > 0) tempScore += 20;
    if (wordCount > 300) tempScore += 20;

    setScore(tempScore);
  };

  // ✅ Save Report to PHP Backend
  const saveReport = async () => {
    const report = { title, description, keywords, content, density, score };

    try {
      const response = await fetch("https://app.saravanabhava.in/api/seoTools.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(report),
      });

      const result = await response.json();
      alert(result.message);
    } catch (err) {
      console.error("Error saving report:", err);
    }
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      <h1 className="text-2xl font-bold mb-4">SEO Tools</h1>

      {/* Title */}
      <label className="block mb-2 font-semibold">Title</label>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="border p-2 rounded w-full mb-4"
      />

      {/* Description */}
      <label className="block mb-2 font-semibold">Meta Description</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        className="border p-2 rounded w-full mb-4"
      />

      {/* Keywords */}
      <label className="block mb-2 font-semibold">Keywords (comma separated)</label>
      <input
        type="text"
        value={keywords}
        onChange={(e) => setKeywords(e.target.value)}
        className="border p-2 rounded w-full mb-4"
      />

      {/* Content */}
      <label className="block mb-2 font-semibold">Content</label>
      <textarea
        rows={8}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="border p-2 rounded w-full mb-4"
      />

      {/* Buttons */}
      <div className="flex gap-4">
        <button
          onClick={analyzeSEO}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Analyze
        </button>
        <button
          onClick={saveReport}
          className="bg-purple-600 text-white px-4 py-2 rounded"
        >
          Save Report
        </button>
      </div>

      {/* Results */}
      {score !== null && (
        <div className="mt-6 p-4 bg-gray-100 rounded">
          <h2 className="text-lg font-bold">SEO Analysis Result</h2>
          <p><strong>SEO Score:</strong> {score} / 100</p>
          <h3 className="mt-2 font-semibold">Keyword Density:</h3>
          <ul>
            {Object.entries(density).map(([kw, val]) => (
              <li key={kw}>
                <strong>{kw}:</strong> {val}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
